import {queries} from '@/shared/integrations/zero'
import {useQuery} from '@rocicorp/zero/react'

export function useGetPatientProtocols(patientId: string | undefined) {
  return useQuery(queries.patients.getPatientProtocols(patientId || ''))
}
